/* =====================================================
   THE ENCHANTED PATH — Floating Lanterns v8
   Glow + Pulse + Scroll Appearance
   ===================================================== */

(function () {

  var article = document.querySelector('.article-template');
  if (!article) return;

  /* ----------------------------------
     LANTERN IMAGE
  ---------------------------------- */

  var LANTERN_URL =
  "https://cdn.shopify.com/s/files/1/0680/1529/2598/files/lantern.png?v=1772848670";


  /* ----------------------------------
     GLOW SETTINGS (EDIT THESE)
  ---------------------------------- */

  var GLOW_STRENGTH = 18;  // glow size
  var GLOW_BRIGHTNESS = 0.8; // glow brightness


  article.style.position = "relative";


  /* ----------------------------------
     CSS
  ---------------------------------- */

  var style = document.createElement("style");

  style.textContent = `

  .enchanted-lantern{

    position:absolute;
    pointer-events:none;

    opacity:0;
    transform:translateY(30px);

    transition:opacity 1.8s ease, transform 1.8s ease;

    transform-origin:top center;
  }

  /* visible after scroll */

  .enchanted-lantern.visible{
    opacity:.65;
    transform:translateY(0);
  }

  .enchanted-lantern img{

    display:block;
    height:auto;

    /* BLUE GLOW */

    filter:
      drop-shadow(0 0 ${GLOW_STRENGTH}px rgba(80,180,255,${GLOW_BRIGHTNESS}))
      drop-shadow(0 0 ${GLOW_STRENGTH*2}px rgba(80,180,255,${GLOW_BRIGHTNESS*.5}));

    animation:lantern-pulse 5s ease-in-out infinite;
  }


  /* FLOATING */

  @keyframes lantern-float{

    0%,100% { transform:translateY(0px); }

    50% { transform:translateY(-14px); }

  }


  /* SWAYING */

  @keyframes lantern-sway{

    0%,100% { rotate:0deg; }

    50% { rotate:3deg; }

  }


  /* LIGHT PULSE */

  @keyframes lantern-pulse{

    0%,100%{

      filter:
        drop-shadow(0 0 ${GLOW_STRENGTH}px rgba(80,180,255,${GLOW_BRIGHTNESS}))
        drop-shadow(0 0 ${GLOW_STRENGTH*2}px rgba(80,180,255,${GLOW_BRIGHTNESS*.5}));

    }

    50%{

      filter:
        drop-shadow(0 0 ${GLOW_STRENGTH*1.6}px rgba(80,180,255,${GLOW_BRIGHTNESS}))
        drop-shadow(0 0 ${GLOW_STRENGTH*3}px rgba(80,180,255,${GLOW_BRIGHTNESS}));

    }

  }


  @media (max-width:1100px){

    .enchanted-lantern{
      display:none !important;
    }

  }

  `;

  document.head.appendChild(style);



  /* =====================================================
     LANTERN CONFIGURATION
     -----------------------------------------------------
     EDIT THESE TO MOVE OR RESIZE LANTERNS
  ===================================================== */

  var lanterns = [

    /* LEFT SIDE */

    { side:"left",  top:6,  size:105, drift:7, sway:6 },

    { side:"left",  top:32, size:85, drift:6, sway:7 },

    { side:"left",  top:60, size:110, drift:8, sway:6 },

    { side:"left",  top:82, size:95, drift:7, sway:6 },


    /* RIGHT SIDE */

    { side:"right", top:14, size:100, drift:7, sway:5 },

    { side:"right", top:44, size:90, drift:6, sway:6 },

    { side:"right", top:70, size:115, drift:8, sway:7 },

    { side:"right", top:92, size:85, drift:6, sway:5 }

  ];


  /* =====================================================
     CREATE LANTERNS
  ===================================================== */

  var created = [];

  lanterns.forEach(function(l){

    var lantern = document.createElement("div");

    lantern.className = "enchanted-lantern";

    lantern.style.top = l.top + "%";

    /* move lanterns ONTO page */

    if(l.side === "left"){
      lantern.style.left = "15px";
    } else {
      lantern.style.right = "15px";
    }

    lantern.style.animation =
      "lantern-float " + l.drift + "s ease-in-out infinite, " +
      "lantern-sway " + l.sway + "s ease-in-out infinite";


    var img = document.createElement("img");

    img.src = LANTERN_URL;
    img.alt = "";
    img.loading = "lazy";

    /* SIZE CONTROL */

    img.style.width = l.size + "px";


    lantern.appendChild(img);

    article.appendChild(lantern);

    created.push(lantern);

  });



  /* =====================================================
     SCROLL APPEAR EFFECT
  ===================================================== */

  function revealLanterns(){

    var trigger = window.innerHeight * 0.85;

    created.forEach(function(l){

      var rect = l.getBoundingClientRect();

      if(rect.top < trigger){

        l.classList.add("visible");

      }

    });

  }

  window.addEventListener("scroll", revealLanterns);

  revealLanterns();

})();